import React, { useState, useEffect } from 'react';
import { ProgressTracker, ProgressTrackerItem } from '@emorg-prd/react-standard';
import '../../newLocation/NewLocationBasePage.css';
import LocationDetails from '../../../shared/formTabs/locationDetails';
import LocationBusinessLine from '../../../shared/formTabs/locationBusinessLine';
import CreateLocation from '../../../shared/formTabs/createLocation';
import LocationSite from '../../../shared/formTabs/locationSite';
import LocationBuilding from '../../../shared/formTabs/locationBuilding';
import ReviewFinish from '../../../shared/formTabs/reviewFinish';
import FormCompletionChecks from '../../../shared/formTabs/FormCompletionChecks';
import SourceSystem from '../../../../api/SourceSystem';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import { useParams } from "react-router-dom";

const LocationUpdate = (props) => {
  const {
    onChange,
    handlePageError,
    isAuthorized,
    locationState,
    locationId,
    showLoadingSpinner,
    setSourceSystemTypeList,
    setSourceSystemList,
    sourceSystemTypeList,
    sourceSystemList,
    locationStateLocationId
  } = props;
  let { id } = useParams(); //location id from route path /editLocation/:id
  const [activeTab, setActiveTab] = useState(1);
  const [isTabCompleteArray, setIsTabCompleteArray] = useState(Array(6).fill(false));
  const [prevTab, setPrevTab] = useState([1]);
  const [isFormComplete, setIsFormComplete] = useState(false);

  useEffect(() => {
    let tempArray = [...isTabCompleteArray];
    tempArray[1] = FormCompletionChecks.checkFormCompleteForCreateLocation(locationState);
    tempArray[2] = FormCompletionChecks.checkFormCompleteForLocationDetails(locationState);
    tempArray[3] = FormCompletionChecks.checkFormCompleteForBusinessLine(locationState);
    tempArray[4] = FormCompletionChecks.checkFormCompleteForSite(locationState);
    tempArray[5] = FormCompletionChecks.checkFormCompleteForBuilding(locationState);
    tempArray[6] = true;
    setIsTabCompleteArray(tempArray);

    SourceSystem.getLocationSourceSystems().then((res) => {
      setSourceSystemList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystemIdType.getAll().then((res) => {
      setSourceSystemTypeList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
  }, []);

  const onSetProgressTabComplete = () => {
    let tempArray = [...isTabCompleteArray];
    if (prevTab === 1) {
      tempArray[1] =
        FormCompletionChecks.checkFormCompleteForCreateLocation(locationState);
    } else if (prevTab === 2) {
      tempArray[2] =
        FormCompletionChecks.checkFormCompleteForLocationDetails(locationState);
    } else if (prevTab === 3) {
      tempArray[3] = FormCompletionChecks.checkFormCompleteForBusinessLine(locationState);
    } else if (prevTab === 4) {
      tempArray[4] = FormCompletionChecks.checkFormCompleteForSite(locationState);
    } else if (prevTab === 5) {
      tempArray[5] = FormCompletionChecks.checkFormCompleteForBuilding(locationState);
    }

    if (activeTab === 6) {
      tempArray[2] = FormCompletionChecks.checkFormCompleteForLocationDetails(locationState);
      tempArray[4] = FormCompletionChecks.checkFormCompleteForSite(locationState);
    }
    setIsTabCompleteArray(tempArray);
    setIsFormComplete(tempArray[1] && tempArray[2] && tempArray[3] && tempArray[4] && tempArray[5]);
  };

  const onNavigateForward = () => {
    setPrevTab(activeTab);
    if (activeTab === 6) {
      return;
    }
    navigateToTab(activeTab + 1);
  };

  const onNavigateBackward = () => {
    setPrevTab(activeTab);
    if (activeTab === 1) {
      return;
    }
    setActiveTab(activeTab - 1);
  };

  const navigateToTab = (tabNum) => {
    setPrevTab(activeTab);
    setActiveTab(tabNum);
  };

  const renderProgressTab = (tabNum, text) => {
    if (tabNum === activeTab) {
      return (
        <ProgressTrackerItem label={text} active>
          {tabNum}
        </ProgressTrackerItem>
      );
    } else if (isTabCompleteArray[parseInt(tabNum)]) {
      return (
        <ProgressTrackerItem
          label={text}
          onClick={() => navigateToTab(tabNum)}
          style={{ cursor: 'pointer' }}
          complete //react unity style for completed progress tracker item
        >
          {tabNum}
        </ProgressTrackerItem>
      );
    } else {
      return (
        <ProgressTrackerItem
          label={text}
          onClick={() => navigateToTab(tabNum)}
          className='incomplete'
          style={{ cursor: 'pointer' }}
        >
          {tabNum}
        </ProgressTrackerItem>
      );
    }
  };

  const renderTabForm = () => {
    switch (activeTab) {
      case 1: {
        return (
          <CreateLocation
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
            locationStateLocationId={locationStateLocationId}
          />
        );
      }
      case 2: {
        return (
          <LocationDetails
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
            setSourceSystemTypeList={setSourceSystemTypeList}
            setSourceSystemList={setSourceSystemList}
            sourceSystemTypeList={sourceSystemTypeList}
            sourceSystemList={sourceSystemList}
          />
        );
      }
      case 3: {
        return (
          <LocationBusinessLine
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 4: {
        return (
          <LocationSite
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 5: {
        return (
          <LocationBuilding
          {...locationState}
          onChange={onChange}
          handlePageError={handlePageError}
          onNavigateForward={onNavigateForward}
          onNavigateBackward={onNavigateBackward}
          onSetProgressTabComplete={onSetProgressTabComplete}
          showLoadingSpinner={showLoadingSpinner}
        />
        );
      }
      case 6: {
        return (
          <ReviewFinish
            locationState={locationState}
            onChange={onChange}
            isAuthorized={isAuthorized}
            handlePageError={handlePageError}
            locationId={locationId}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
            isFormComplete={isFormComplete}
            setIsFormComplete={setIsFormComplete}
            sourceSystemTypeList={sourceSystemTypeList}
            sourceSystemList={sourceSystemList}
          />
        );
      }
      default: {
        alert(activeTab);
      }
    }
  };
  return (
    <div>
      <ProgressTracker style={{ paddingLeft: '30px', paddingRight: '30px' }}>
        {renderProgressTab(1, 'Create Location')}
        {renderProgressTab(2, 'Location Details')}
        {renderProgressTab(3, 'Business Line')}
        {renderProgressTab(4, 'Site')}
        {renderProgressTab(5, 'Buildings')}
        {renderProgressTab(6, 'Review and Finish')}
      </ProgressTracker>
      {renderTabForm()}
    </div>
  );
};

export default LocationUpdate;
